<template>
  <a-input
    v-model:value="model"
    :id="IdAdapter.fromName(name)"
    :disabled="disabled"
    :placeholder="placeholder"
  >
    <template #suffix>
      <slot name="suffix"></slot>
    </template>
  </a-input>
</template>

<script setup>
  /**
   * Компонент-фасад для компонента <a-input/> из библиотеки ant-design-vue.
   * Его нужно использовать в коде компонентов вместо <a-input/>.
   * 
   * Пример использования:
   * <input-facade
   *   v-model="form.result"
   *   name="result"
   *   placeholder="Сформулируйте результат"
   * >
   *   <template #suffix>
   *     <img src="delete.svg" alt=""/>
   *   </template>
   * </input-facade>
   */

  import { defineModel } from 'vue';
  import { IdAdapter } from '../adapters/id-adapter';

  const model = defineModel();

  defineProps({
    // Поле name, которое передается в <form-item-facade/>
    name: {
      type: [Array, String],
      required: true,
    },

    // Whether the input is disabled
    disabled: {
      type: Boolean,
      default: false,
    },

    // Текст подсказки, что нужно ввести в поле
    placeholder: {
      type: String,
      default: '',
    },
  });
</script>

<style lang="scss" scoped>

</style>